import { Img } from './Img';
import { SectionHead, Reveal } from './Bits';

const SHOTS = [
  { src: 'https://images.unsplash.com/photo-1743517894265-c86ab035adef?auto=format&fit=crop&w=1200&q=80', label: 'Crispy dosa, banana leaf', alt: 'Crispy masala dosa on a banana leaf with sambar and coconut chutney', span: 'md:col-span-2 md:row-span-2' },
  { src: 'https://images.unsplash.com/photo-1693302050215-66ae33076745?auto=format&fit=crop&w=1000&q=80', label: 'Filter coffee & Irani chai', alt: 'Hot filter coffee and traditional Irani chai served in glass cups', span: 'md:row-span-2' },
  { src: 'https://images.unsplash.com/photo-1596797038530-2c107229654b?auto=format&fit=crop&w=1200&q=80', label: 'Chettinad curries', alt: 'Rich Chettinad curry with aromatic spices and coconut gravy', span: '' },
  { src: 'https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?auto=format&fit=crop&w=1200&q=80', label: 'Dum biryani', alt: 'Traditional Hyderabadi dum biryani—slow-cooked basmati with marinated meat and saffron', span: '' },
  { src: 'https://images.unsplash.com/photo-1728910156510-77488f19b152?auto=format&fit=crop&w=1400&q=80', label: 'The full spread', alt: 'Complete spread of Indian dishes including biryani, curries, breads and sides', span: 'md:col-span-2' },
  { src: 'https://images.unsplash.com/photo-1758910536889-43ce7b3199fd?auto=format&fit=crop&w=1000&q=80', label: 'Sweet endings', alt: 'Indian desserts including gulab jamun, kheer, falooda and traditional sweets', span: '' },
];

export function Gallery() {
  return (
    <section className="wrap py-20 md:py-28">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
        <SectionHead kicker="A Feast for the Senses" title="Straight from our kitchen" intro="Griddled, simmered and plated to order — this is what lands on your table." />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 auto-rows-[160px] md:auto-rows-[200px]">
        {SHOTS.map((s, i) => (
          <Reveal as="div" key={s.src} delay={i * 70} className={`group relative overflow-hidden rounded-[var(--pe-radius)] ${s.span}`}>
            <Img src={s.src} alt={s.alt || s.label} className="h-full w-full" imgClassName="group-hover:scale-105" />
            <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(20,14,10,0.7) 0%, transparent 55%)' }} />
            <span className="absolute left-4 bottom-3.5 font-display text-white text-[0.95rem] md:text-base drop-shadow">
              {s.label}
            </span>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
